import { NATIVE_ROUTE } from '~/constants/routes';
import { hasNativeRouteRedirection } from '~/helpers/navigation/nativeRoutingRedirection';
import { CountryCodeValue } from '~/types/localization/localizationHelperTypes';
import { ProductVariantExtended } from '~/types/product/ProductVariantExtended';

export const addNativeRoutingToProductUrl = (
  productUrl: string,
  countryCode: CountryCodeValue,
): string => {
  if (!hasNativeRouteRedirection(countryCode)) {
    return productUrl;
  }
  const normalizedProductUrl = productUrl.startsWith('/') ? productUrl : `/${productUrl}`;
  return `/${NATIVE_ROUTE.PRODUCT}${normalizedProductUrl}`;
};

export const transformProductsForNativeRouting =
  (products: ProductVariantExtended[], countryCode: CountryCodeValue): ProductVariantExtended[] => {
    return (products || []).map((product) => {
      const productUrl = hasNativeRouteRedirection(countryCode)
        ? `${NATIVE_ROUTE.PRODUCT}/${product._slug}`
        : product._slug;
      return {
        ...product,
        _slug: productUrl,
      };
    });
  };
